var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-data-table', {
    staticClass: "elevation-1 my-7",
    class: {
      'on-add': _vm.onAddingProcess
    },
    attrs: {
      "headers": _vm.bannerHeaders,
      "items": _vm.tenant.banners
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function () {
        return [_c('v-toolbar', {
          attrs: {
            "flat": ""
          }
        }, [_c('v-toolbar-title', [_vm._v("Banners")]), _c('v-spacer'), _c('v-dialog', {
          attrs: {
            "max-width": "500px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref) {
              var on = _ref.on,
                attrs = _ref.attrs;
              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "mb-2",
                attrs: {
                  "color": "accent",
                  "dark": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v(" New Item")])];
            }
          }]),
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v;
            },
            expression: "dialog"
          }
        }, [_c('v-card', [_c('v-card-title', [_c('span', {
          staticClass: "text-h5"
        }, [_vm._v(_vm._s(_vm.editingItem ? "Edit" : "Create New") + " Item")])]), _c('v-card-text', [_c('v-container', [_c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "12",
            "md": "12"
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.types,
            "menu-props": {
              bottom: true,
              offsetY: true
            },
            "hide-details": "",
            "item-text": "text",
            "item-value": "value",
            "label": "Type",
            "outlined": ""
          },
          model: {
            value: _vm.modalPayload.type,
            callback: function ($$v) {
              _vm.$set(_vm.modalPayload, "type", $$v);
            },
            expression: "modalPayload.type"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "12",
            "md": "12"
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.localeOptions,
            "menu-props": {
              bottom: true,
              offsetY: true
            },
            "hide-details": "",
            "item-text": "text",
            "item-value": "value",
            "label": "Language",
            "clearable": "",
            "outlined": ""
          },
          model: {
            value: _vm.modalPayload.locale,
            callback: function ($$v) {
              _vm.$set(_vm.modalPayload, "locale", $$v);
            },
            expression: "modalPayload.locale"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "12",
            "md": "12"
          }
        }, [_c('v-text-field', {
          attrs: {
            "hide-details": "auto",
            "label": "Image Path",
            "outlined": ""
          },
          model: {
            value: _vm.modalPayload.imagePath,
            callback: function ($$v) {
              _vm.$set(_vm.modalPayload, "imagePath", $$v);
            },
            expression: "modalPayload.imagePath"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "12",
            "md": "12"
          }
        }, [_c('v-text-field', {
          attrs: {
            "hide-details": "auto",
            "label": "Link",
            "outlined": ""
          },
          model: {
            value: _vm.modalPayload.link,
            callback: function ($$v) {
              _vm.$set(_vm.modalPayload, "link", $$v);
            },
            expression: "modalPayload.link"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "12",
            "md": "12"
          }
        }, [_c('v-checkbox', {
          attrs: {
            "hide-details": "",
            "label": "Enabled"
          },
          model: {
            value: _vm.modalPayload.enabled,
            callback: function ($$v) {
              _vm.$set(_vm.modalPayload, "enabled", $$v);
            },
            expression: "modalPayload.enabled"
          }
        })], 1)], 1)], 1)], 1), _c('v-card-actions', {
          staticClass: "pr-8 pb-8"
        }, [_c('v-spacer'), _c('v-btn', {
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              _vm.dialog = false;
            }
          }
        }, [_vm._v(" Cancel")]), _c('v-btn', {
          attrs: {
            "color": "accent"
          },
          on: {
            "click": _vm.handleSave
          }
        }, [_vm._v(" Save")])], 1)], 1)], 1), _c('v-dialog', {
          attrs: {
            "max-width": "500px"
          },
          model: {
            value: _vm.deleteDialog,
            callback: function ($$v) {
              _vm.deleteDialog = $$v;
            },
            expression: "deleteDialog"
          }
        }, [_c('v-card', [_c('v-card-title', {
          staticClass: "text-h5"
        }, [_vm._v("Are you sure you want to delete this item?")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              _vm.deleteDialog = false;
            }
          }
        }, [_vm._v("Cancel")]), _c('v-btn', {
          attrs: {
            "color": "accent"
          },
          on: {
            "click": _vm.confirmDeleteItem
          }
        }, [_vm._v("OK")]), _c('v-spacer')], 1)], 1)], 1)], 1)];
      },
      proxy: true
    }, {
      key: `item.type`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.typeText(item.type)) + " ")];
      }
    }, {
      key: `item.locale`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm.localeText(item.locale)) + " ")];
      }
    }, {
      key: `item.enabled`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('v-icon', {
          attrs: {
            "small": "",
            "color": item.enabled ? 'greeny' : 'grey'
          }
        }, [_vm._v(" " + _vm._s(item.enabled ? "mdi-check-circle" : "mdi-close-circle") + " ")])];
      }
    }, {
      key: `item.actions`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": "",
            "color": "third"
          },
          on: {
            "click": function ($event) {
              return _vm.editItem(item);
            }
          }
        }, [_vm._v(" mdi-pencil")]), _c('v-icon', {
          attrs: {
            "small": "",
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteItem(item);
            }
          }
        }, [_vm._v(" mdi-delete")])];
      }
    }], null, true)
  });

}
var staticRenderFns = []

export { render, staticRenderFns }